// @flow

import { takeLatest, call, select, put } from 'redux-saga/effects';
import type { Saga } from 'redux-saga';
import WebPushNotificationsApi from '~/sdk/notifications/webPush/ApiNotifications';
import clientConfig from '~/../parameters/client/config';
import { getVerticalId, getCountryCode } from '~/common/selectors/config';
import { DISABLE_ALL_NOTIFICATIONS } from './actionTypes';
import { searchNotificationsSelector } from '../SearchNotifications/selectors';
import { disableAllSearchNotifications } from './utils';
import { openSnackbarError, closeSnackbar, openSnackbar } from '../Snackbar/actions';
import { setSearchNotifications, restoreSearchNotifications } from '../SearchNotifications/actions';
import messages from './messages';
import { subscriptionIdSelector } from '../Authentication/selectors';

const webPushNotificationsApi = new WebPushNotificationsApi(clientConfig.notificationApi);

export function* disableAllSearchNotificationsSaga(): Saga<void> {
  yield put(closeSnackbar());

  const searchNotifications = yield select(searchNotificationsSelector);

  const disabledSearchNotifications = disableAllSearchNotifications(searchNotifications);

  // Eager user response with full rollback on error
  yield put(setSearchNotifications(disabledSearchNotifications));

  const subscriptionId = yield select(subscriptionIdSelector);
  const verticalId = yield select(getVerticalId);
  const countryCode = yield select(getCountryCode);

  const options = {
    subscriptionId,
    verticalId,
    countryCode,
  };

  try {
    yield call(
      [webPushNotificationsApi, webPushNotificationsApi.disableAllSearchNotifications],
      options
    );
    yield put(openSnackbar(messages.disableNotificationsConfirmation));
  } catch (error) {
    yield put(openSnackbarError());
    yield put(restoreSearchNotifications(searchNotifications));
  }
}

export default function* sagas(): Saga<void> {
  yield takeLatest(DISABLE_ALL_NOTIFICATIONS, disableAllSearchNotificationsSaga);
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/DisableSearchNotifications/sagas.js